(function () {

    'use strict';

    angular.module('app').controller('AccountingHistoricalBillingDetailsController', AccountingHistoricalBillingDetailsController);

    AccountingHistoricalBillingDetailsController.$inject = [
        '$routeParams',
        'Carrier',
        'AccountingService',
        'toastr',
        'Units',
        '$location',
        'AccountingHistoricalBillingShipmentsTableService',
        '$uibModal',
        '$q',
        '$window'
    ];

    function AccountingHistoricalBillingDetailsController(
        $routeParams,
        Carrier,
        AccountingService,
        toastr,
        Units,
        $location,
        AccountingHistoricalBillingShipmentsTableService,
        $uibModal,
        $q,
        $window
    ){
        const vm = this;
        vm.id = $routeParams.id;
        vm.markAsPaid = markAsPaid; 
        vm.showIssueCreditDebitNote = showIssueCreditDebitNote;
        vm.back = back;

        init();
        function init() {
            Carrier.getCarriers(data => {
                vm.carriers = data;
            }, () => {
                toastr.error('Failed to fetch available Carriers. Refresh the page and try again.', 'Error');
            });
            vm.data = {};
            getHistoricalBillingData().then(data=>{
                initBilledShipmentsTable(); 
            });
        }

        function getHistoricalBillingData(){
            if(vm.id){
                const defer = $q.defer();
                vm.isFetching = true;
                AccountingService.Invoices.getHistoricalBilling(data => {
                    vm.data = data; 
                   
                    vm.isFetching = false;
                    defer.resolve(data);
                }, error => {
                    vm.isFetching = false;
                    toastr.error(error.message, "Error");
                    $location.path("/accounting/historical-billing");
                    defer.reject(error);
                }, vm.id);
                return defer.promise;
            }
        }

        function initBilledShipmentsTable() {
            vm.shipments = new AccountingHistoricalBillingShipmentsTableService(vm.id).tableData;
            vm.shipments.resetFilters();
        }

        function markAsPaid(){
            vm.markingAsPaid = true;
            AccountingService.CustomerBilling.markAsPaid(data => {
                toastr.success("Invoice is now paid.");
                getHistoricalBillingData();
                vm.markingAsPaid = false;
            }, error => {
                toastr.error("Error", error.message);
                vm.markingAsPaid = false;
            }, vm.id); 
        }

        function showIssueCreditDebitNote(){
            const selectedShipments = vm.shipments.data.filter( item => item.isSelected === true );
            if(selectedShipments.length !== 0) {
                $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: '/templates/pages/accounting/modals/issue-credit-note-modal.html',
                    controller: 'IssueCreditNoteModalController',
                    controllerAs: 'vm',
                    windowClass: 'full-height-modal',
                    size: 'lg',
                    appendTo: $('body'),
                    resolve: {
                        shipments: () => {
                            return selectedShipments;
                        },
                        invoiceData: () => {
                            return vm.data;
                        }
                    }
                });
            }
            else {
                toastr.warning('Please select  a shipment')
            }
        }

        function back(){
            $window.history.back();
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/accounting/AccountingHistoricalBillingDetailsController.js